import { useState } from 'react';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d5lh2ov72m0gvhnvddr0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-12 sm:py-16 md:py-20 lg:py-24 bg-gradient-to-br from-[#FF6B6B] to-[#ff5252]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
        <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-6 sm:mb-8">
          <i className="ri-mail-line text-4xl sm:text-5xl text-white w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center"></i>
        </div>

        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-3 sm:mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
          Stay Updated
        </h2>
        <p className="text-base sm:text-lg md:text-xl text-white/95 mb-8 sm:mb-10 md:mb-12 leading-relaxed max-w-2xl mx-auto px-4">
          Get expert tips, industry insights, and exclusive offers delivered to your inbox
        </p>

        <form onSubmit={handleSubmit} className="max-w-xl mx-auto" data-readdy-form id="newsletter-form">
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              required
              className="flex-1 px-5 sm:px-6 py-4 sm:py-5 rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-4 focus:ring-white/30 text-base sm:text-lg"
            />
            <button
              type="submit"
              disabled={isSubmitting}
              className="bg-gray-900 text-white px-8 sm:px-10 py-4 sm:py-5 rounded-lg font-semibold hover:bg-gray-800 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap text-base sm:text-lg shadow-lg hover:shadow-xl"
            >
              {isSubmitting ? 'Subscribing...' : 'Subscribe'}
            </button>
          </div>

          {/* Status Messages */}
          {submitStatus === 'success' && (
            <div className="mt-4 bg-white/95 backdrop-blur-sm border-2 border-white text-gray-900 px-4 py-3 rounded-lg">
              <p className="font-semibold">Successfully subscribed!</p>
              <p className="text-sm">Thank you for joining our newsletter.</p>
            </div>
          )}

          {submitStatus === 'error' && (
            <div className="mt-4 bg-red-500/95 backdrop-blur-sm border-2 border-red-600 text-white px-4 py-3 rounded-lg">
              <p className="font-semibold">Something went wrong.</p>
              <p className="text-sm">Please try again later.</p>
            </div>
          )}
        </form>
      </div>
    </section>
  );
}
